/*
 * Botanika — Order Bump
 * Delegated add-to-cart for the cart order-bump card.
 * Drawer: adds via /cart/add.js with sections:['minicart-form'] and re-renders the drawer
 *         (mirrors the theme's own CartNotification re-render), then refreshes count / free-ship / header total.
 * Cart page: adds then reloads.
 * Guarded single-init.
 */
(function () {
  "use strict";
  if (window.__botanikaOrderBumpInit) return;
  window.__botanikaOrderBumpInit = true;

  function addUrl() {
    if (window.routes && routes.cart_add_url) return routes.cart_add_url;
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + "cart/add.js";
    }
    return "/cart/add.js";
  }

  function isCartPage() {
    return (
      document.body.classList.contains("template-cart") ||
      /\/cart(\/|$|\?)/.test(window.location.pathname)
    );
  }

  function updateCartCount(count) {
    document.querySelectorAll(".cart-count").forEach(function (el) {
      if (el.classList.contains("cart-count-drawer")) {
        el.innerHTML = "(" + count + ")";
      } else {
        el.innerHTML = count > 100 ? "~" : count;
      }
    });
  }

  function refreshCartMeta() {
    fetch("/cart.json")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || cart.item_count === undefined) return;
        updateCartCount(cart.item_count);
        var headerTotal = document.querySelector("header-total-price");
        if (headerTotal && typeof headerTotal.updateTotal === "function") {
          headerTotal.updateTotal(cart);
        }
        var freeShip = document.querySelector("free-ship-progress-bar");
        if (freeShip && typeof freeShip.init === "function") {
          freeShip.init(cart.items_subtotal_price);
        }
      })
      .catch(function () {});
  }

  // The initial drawer DOM (snippets/minicart.liquid) does not contain the bump.
  // On non-cart pages, if the cart has items and the drawer has no bump yet,
  // pull the freshly-rendered card from the minicart-form section and inject it.
  // After any theme cart re-render, the drawer's #minicart-form already includes
  // the bump (sections/minicart-form.liquid renders it), so this only fills the gap
  // on first load / opening the drawer via the header icon.
  function ensureInitialDrawerBump() {
    if (isCartPage()) return;
    var mf = document.getElementById("minicart-form");
    if (!mf) return;
    if (mf.querySelector(".botanika-ob")) return;
    if (!mf.querySelector(".cart-item")) return; // empty cart: nothing to offer
    var url = window.location.pathname + "?section_id=minicart-form";
    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var bump = doc.querySelector(".botanika-ob");
        if (!bump) return;
        var mf2 = document.getElementById("minicart-form");
        if (!mf2 || mf2.querySelector(".botanika-ob")) return;
        var form = mf2.querySelector("#minicart");
        if (form) {
          form.insertAdjacentHTML("afterend", bump.outerHTML);
        } else {
          var scroll = mf2.querySelector(".overflow-y-scroll") || mf2;
          scroll.insertAdjacentHTML("afterbegin", bump.outerHTML);
        }
        if (typeof BlsLazyloadImg !== "undefined" && BlsLazyloadImg.init) {
          BlsLazyloadImg.init();
        }
      })
      .catch(function () {});
  }

  function renderDrawer(sectionHtml) {
    var target = document.getElementById("minicart-form");
    if (!target || !sectionHtml) return;
    var parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    var fresh = parsed.querySelector("#minicart-form");
    if (fresh) target.innerHTML = fresh.innerHTML;
    // Re-bind the theme's drawer addon/giftwrap/close handlers on the fresh markup.
    var cartNotification = document.querySelector("cart-notification");
    if (cartNotification && typeof cartNotification.cartAction === "function") {
      try {
        cartNotification.cartAction();
      } catch (e) {}
    }
    if (typeof BlsLazyloadImg !== "undefined" && BlsLazyloadImg.init) {
      BlsLazyloadImg.init();
    }
  }

  function notify(message, type) {
    try {
      if (window.CartUtils && CartUtils.showToast) {
        CartUtils.showToast(message, type || "error");
        return;
      }
      if (typeof showToast === "function") {
        showToast(
          message,
          3000,
          type === "success" ? "modal-success" : "modal-error"
        );
      }
    } catch (e) {}
  }

  function restore(btn, label, prevText) {
    btn.classList.remove("is-loading");
    btn.removeAttribute("disabled");
    if (label && prevText !== null) label.textContent = prevText;
  }

  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest("[data-botanika-ob-add]");
    if (!btn) return;
    evt.preventDefault();
    if (btn.classList.contains("is-loading")) return;

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    var label = btn.querySelector("[data-ob-btn-label]");
    var prevText = label ? label.textContent : null;
    btn.classList.add("is-loading");
    btn.setAttribute("disabled", "disabled");
    if (label) label.textContent = btn.getAttribute("data-label-loading") || "Adicionando...";

    var onCart = isCartPage();
    var body = { id: Number(variantId), quantity: 1 };
    if (!onCart) {
      body.sections = ["minicart-form"];
      body.sections_url = window.location.pathname;
    }

    fetch(addUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        // Shopify add errors carry a truthy `status` (HTTP 422) and a `description`.
        if (!result.ok || (result.data && result.data.status)) {
          notify(
            (result.data && result.data.description) ||
              "Não foi possível adicionar. Tente novamente.",
            "error"
          );
          restore(btn, label, prevText);
          return;
        }
        if (onCart) {
          window.location.reload();
          return;
        }
        if (result.data.sections && result.data.sections["minicart-form"]) {
          renderDrawer(result.data.sections["minicart-form"]);
        }
        refreshCartMeta();
        // Drawer markup was replaced; the button no longer exists — no restore needed.
      })
      .catch(function () {
        notify("Erro de conexão. Tente novamente.", "error");
        restore(btn, label, prevText);
      });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureInitialDrawerBump);
  } else {
    ensureInitialDrawerBump();
  }
})();
